import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MDBModalRef } from "ng-uikit-pro-standard";
import {
  showError,
  showSucess,
} from "src/app/shared/utils/functions/notification.function";

import { CognitoService } from "src/app/shared/services/cognito.service";
import { PasswordValidator } from "src/app/portal/utils/password-validator";
import { Router } from "@angular/router";

@Component({
  selector: "app-modal-reset-password-token",
  templateUrl: "./modal-reset-password-token.component.html",
  styleUrls: ["./modal-reset-password-token.component.scss"],
})
export class ModalResetPasswordTokenComponent implements OnInit {
  mdbRef: MDBModalRef;

  formPasswordToken: FormGroup;

  username: string;
  email: string;

  constructor(
    private router: Router,
    private modalRef: MDBModalRef,
    private cognitoService: CognitoService
  ) {}

  ngOnInit(): void {
    this.createFormPasswordToken();
  }

  resendEmailCode() {
    this.cognitoService.resetPassword(this.username).subscribe(
      (res) => {
        return showSucess(
          "",
          "Um novo token foi enviado para o email informado."
        );
      },
      (e) => {
        return showError("", e.message);
      },
      () => {}
    );
  }

  validatePassword() {
    if (
      this.newPassword.errors != null ||
      this.newPassword.errors != undefined
    ) {
      if (
        this.newPassword?.errors.strong ||
        this.newPassword?.errors.minlength
      ) {
        return showError(
          "",
          "Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula, 1 letra minúscula, 1 caractere especial e 1 número."
        );
      }
    }

    if (this.newPassword.value !== this.confirmNewPassword.value) {
      return showError("", "As senhas informadas não coincidem");
    }

    if (this.formPasswordToken.invalid) {
      return showError(
        "",
        "Valide as informações do formulário para prosseguir."
      );
    }

    return this.cognitoService
      .confirmPassword(this.username, this.newPassword.value, this.token.value)
      .subscribe(
        (res) => {
          this.close();
          this.router.navigate(["login"]);
          showSucess("", "Senha alterada com sucesso");
        },
        (e) => showError("", e.message)
      );
  }

  createFormPasswordToken() {
    this.formPasswordToken = new FormGroup({
      token: new FormControl("", [
        Validators.required,
        Validators.minLength(6),
      ]),
      newPassword: new FormControl("", [
        Validators.required,
        PasswordValidator.strong,
        Validators.minLength(8),
      ]),
      confirmNewPassword: new FormControl("", [Validators.required]),
    });
  }

  close() {
    return this.modalRef.hide();
  }

  //GET and SETTER
  get token() {
    return this.formPasswordToken.get("token");
  }

  get newPassword() {
    return this.formPasswordToken.get("newPassword");
  }

  get confirmNewPassword() {
    return this.formPasswordToken.get("confirmNewPassword");
  }
}
